import { render, staticRenderFns } from "./DetailCrmMetrics.vue?vue&type=template&id=782042aa&scoped=true"
import script from "./DetailCrmMetrics.vue?vue&type=script&lang=js"
export * from "./DetailCrmMetrics.vue?vue&type=script&lang=js"
import style0 from "./DetailCrmMetrics.vue?vue&type=style&index=0&id=782042aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782042aa",
  null
  
)

export default component.exports